<template>
    <div>
        <div v-if="buttonTop" class="mb-3">
            <ProceduresForm v-if="checkUserPermission('procedure', 'can_add')"  class="mt-3" :callback="callback" :small="small"/>
        </div>
        <b-overlay :show="confirm" no-wrap @shown="onShown">
            <template #overlay>
                <div ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label">
                    <p class="text-center">
                        <i class="fa-light fa-xmark text-danger"></i> <strong class="text-danger">DELETE PROCEDURE ON {{ toLocaleDate(selected?.created) }} </strong>
                    </p>
                    <div class="text-center">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">Cancel</b-button>
                        <b-button variant="outline-success" @click="onConfirmed">Confirm</b-button>
                    </div>
                </div>
            </template>
        </b-overlay>
       <b-overlay 
            :show="$store.getters['loading/isLoading']('procedures')"
            rounded="sm"
            variant="light"
            spinner-variant="primary"
            :opacity="0.80"
            blur="2px">
            <b-card-body class="p-0">
                <b-table
                    ref="table"
                    class="m-0"
                    responsive
                    stacked="sm"
                    show-empty
                    striped
                    hover
                    :fixed="fixed"
                    :small="small"
                    :borderless="borderless"
                    primary-key="id"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="items"
                    :fields="fields"
                    :no-sort-reset="true"
                    :sort-by.sync="sortedBy"
                    :sort-desc.sync="sortedDesc"
                    :no-border-collapse="false">

                    <template v-slot:cell(description)="row">
                        <ProcedureDescriptionForm :item="row.item" />
                    </template>

                    <template v-slot:cell(actions)="row">
                        <b-button size="sm" v-if="checkUserPermission('procedure', 'can_delete')" variant="danger" @click="onRemoveItem(row)" v-b-tooltip.hover title="Remove procedure"><i class="fa-light fa-xmark"></i></b-button> 
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    <template v-slot:empty="scope">
                        <div class="small text-muted text-center my-2">
                            <span>n/a</span>
                        </div>
                    </template>
                    <template v-slot:custom-foot="scope">
                        <b-tr class="border-top">
                            <b-td colspan="4" class="align-middle" variant="light" style="background: #fff;">
                                Showing {{ startIndex }} to {{ endIndex }} of {{ totalRows }}
                            </b-td>
                            <b-td colspan="3" class="text-right align-middle" variant="light" style="background: #fff;">
                                <b-pagination class="m-0" prev-text="Prev" next-text="Next" hide-goto-end-buttons align="right" :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                            </b-td>
                        </b-tr>
                    </template>
                </b-table>
                <b-card-footer v-if="!buttonTop">
                    <ProceduresForm v-if="checkUserPermission('procedure', 'can_add')" class="mt-3" :callback="callback" :small="small"/>
                </b-card-footer>
            </b-card-body>
        </b-overlay>
    </div>
</template>
<script>
import Vue from 'vue'
import ComponentBaseExtension from '@/core/components/ComponentBaseExtension'
import { mapGetters, mapActions, mapState } from 'vuex'

import ProceduresForm from './ProceduresForm'
import ProcedureDescriptionForm from './ProcedureDescriptionForm'

import cloneDeep from 'lodash/cloneDeep'

export default ComponentBaseExtension.extend({
    name: 'procedures-base',
    components: {
        ProceduresForm,
        ProcedureDescriptionForm
    },
    data() {
        return {
            addNew: false,
            fields: [
                { key: 'created', label: 'Date/Time', class: {"align-middle" : true, "small": this.small }, formatter: (value) => this.toLocaleDate(value) },
                { key: 'decursus_date', label: 'Decursus', class: {"align-middle" : true, "small": this.small }, formatter: (value) => this.toLocaleDate(value) },
                { key: 'type.code', label: 'Code', class: {"align-middle" : true, "small": this.small } },
                { key: 'type.name', label: 'Name', class: {"align-middle" : true, "small": this.small } },
                { key: 'description', label: 'Description', class: {"align-middle" : true, "small": this.small }, formatter: (value) => value ? value : 'n/a' },
                { key: 'type.resource', label: 'Resource', class: {"align-middle" : true, "small": this.small } },
                { key: 'type.tariff', label: 'Tariff', class: {"align-middle" : true, "small": this.small } },
                { key: "actions", label: "", class: {"align-middle" : true,  "text-right": true, "small": this.small } },
            ],

            currentPage: 1,
            perPage: 5,
            sortedBy: 'created',
            sortedDesc: true,

            confirm: false,
            selected: null,
        }
    },
    computed: {
        ...mapGetters('procedures', ['getPatientProcedures']),
        items() {
            return cloneDeep(this.getPatientProcedures())
        },
        totalRows() {
            return this.items.length
        },
        startIndex() {
            return (this.currentPage - 1) * this.perPage + 1
        },
        endIndex() {
            var end = this.totalRows
            if (this.perPage < this.totalRows) {
                end = this.perPage * this.currentPage
                if (end > this.totalRows) {
                    end = this.totalRows
                }
            }
            return end
        }
    },
    methods: {
        ...mapActions('procedures', ['filterProcedures', 'getProceduresForCurrentPatient', 'deleteDecursusProcedure']),
        async loadForPatient(patient) {
            await this.getProceduresForCurrentPatient()
        },
        onRemoveItem(row) {
            this.confirm = true
            this.selected = row.item
        },
        onConfirmed() {
            if (this.selected) {
                this.deleteDecursusProcedure(this.selected.id).then(() => {
                    this.notify("Patient procedure removed", "Patient procedure was removed successfully")
                    this.confirm = false
                    this.selected = null

                })
                .catch(errors => {
                    this.notify("Error", "Something went wrong", 'danger')
                    this.confirm = false
                    this.selected = null
                })
            }
        },
        onShown() {
            // Focus the dialog prompt
            this.$refs.dialog?.focus()
        },
        onCancel() {
            this.confirm = false
            this.selected = null
            // EventBus.$emit('prescription-copied', null)
        },
    }
})
</script>